'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ../~/react-autowhatever/dist/index.js
// module id = 932
// module chunks = 0